// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Card, color } from '@kintent/glide';

export const SecurityPostureStatementWrapper = styled.div`
  width: 1200px;
  margin-left: auto;
  margin-right: auto;

  padding-top: 36px;

  @media (min-width: 1920px) {
    width: 1400px;
  }

  h3 {
    font-weight: 600;
  }
`;

export const Section = styled(Card)`
  width: 1200px;

  @media (min-width: 1920px) {
    width: 1400px;
  }

  margin-left: auto;
  margin-right: auto;

  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 16px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  & .show-all-notifications-cta {
    text-align: center;

    a {
      font-weight: 500;
    }
  }
`;

export const GridItemHeading = styled.div`
  display: flex;
  justify-content: space-between;

  & .notification-section-title {
    font-weight: 600;
  }

  & .notification-section-show-all-cta {
    font-weight: 600;
  }
`;

export const NotificationListGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  & .notification-list-item {
    display: flex;
    flex-direction: column;
    gap: 12px;

    border-radius: 16px;

    & .notification-item-title {
      font-weight: 600;
    }

    & .notification-item-description {
      display: -webkit-box;

      overflow: hidden;

      line-clamp: 2;
      -webkit-line-clamp: 2;

      -webkit-box-orient: vertical;

      font-weight: 500;
      font-family: Lato;
    }

    & .notification-item-actions {
      margin-top: auto;
      padding-top: 12px;
    }

    & .notification-subscribe-icon-button {
      border: 1px solid ${({ theme }) => color(theme.colorV2.system.border, 50)};
      padding: 10px 12px;
    }
  }
`;
